import React, { useEffect } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { getPatientAdvPayments } from "../../erp-billing/ERPActions/erpActions";
 import { useOrganization } from "../../../configurations/OrganizationContext";
import { ORG_CODES } from "../../../shared/constants";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

function PrintPatientCard(props) {
  const { patientInfo, regDate } = props;
  const org = useOrganization();
  const isVedamaayu = org?.orgCode === ORG_CODES.VEDAMAAYU;
  const name =
    patientInfo?.fullName ||
    [patientInfo?.fname, patientInfo?.mname, patientInfo?.lname]
      .filter(Boolean)
      .join(" ") ||
    "";
  useEffect(() => {
    props.parentCallBack();
    fetchAndPrint();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const fetchAndPrint = async () => {
    let advPayments = [];
    try {
      const locationIds = patientInfo?.locationId ? [patientInfo.locationId] : [];

      const payments = await getPatientAdvPayments(
        patientInfo?.patientId || patientInfo?.id,
        patientInfo?.visitId,
        locationIds,
        null,
        null,
        patientInfo?.locationId || null
      );
      console.log("payments raw response:", payments);
      if (payments?.erpResp?.customerPaymentInfo) {
        advPayments = payments.erpResp.customerPaymentInfo;
      }
      console.log("final advPayments:", advPayments);
    } catch (err) {
      console.error("Failed to fetch advance payments:", err);
    }
    printCard(advPayments);
  };

  const buildDocDefinition = (advPayments = []) => {
    const advTableBody = [
      [
        { text: "Receipt ID", bold: true, fontSize: 9, alignment: "center" },
        { text: "Amount", bold: true, fontSize: 9, alignment: "center" },
        { text: "Date", bold: true, fontSize: 9, alignment: "center" },
      ],
      ...(advPayments.length > 0
        ? advPayments.map((p) => [
            { text: p.id || p.paymentId || "—", fontSize: 9, alignment: "center" },
            {
              text: p.receivedAmount != null ? `₹ ${p.receivedAmount}` : "—",
              fontSize: 9,
              alignment: "center",
            },
            { text: formatDate(p.paymentDate), fontSize: 9, alignment: "center" },
          ])
        : [
            [
              {
                text: "No advance payments found.",
                fontSize: 9,
                color: "#888888",
                italics: true,
                colSpan: 3,
                alignment: "center",
              },
              {},
              {},
            ],
          ]),
    ];

    return {
      pageSize: "A4",
      pageMargins: [10, 10, 10, 10],
      content: [
        // ── Patient Name ──
        {
          text: name.toUpperCase(),
          fontSize: 18,
          bold: true,
          alignment: "center",
          margin: [0, 10, 0, 20],
        },

        // ── Patient Info Columns (table-based for perfect colon alignment) ──
        // ── Patient Info Columns (table-based for perfect colon alignment) ──
        {
          columns: [
            {
              width: "50%",
              table: {
                widths: [65, "*"],
                body: [
                  [
                    { text: "Main No.", bold: true, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, 6] },
                    { text: `:  ${patientInfo?.id || "—"}`, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, 6] },
                  ],
                  [
                    { text: "IP/OP No.", bold: true, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, 6] },
                    { text: `:  ${patientInfo?.ipopnumber || "—"}`, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, 6] },
                  ],
                  [
                    { text: "Room", bold: true, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, isVedamaayu ? 0 : 6] },
                    { text: `:  ${patientInfo?.roomName || "—"}`, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, isVedamaayu ? 0 : 6] },
                  ],
                  ...(!isVedamaayu
                    ? [
                        [
                          { text: "Doctor", bold: true, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, 0] },
                          { text: `:  ${patientInfo?.doctorName || "—"}`, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, 0] },
                        ],
                      ]
                    : []),
                ],
              },
              layout: "noBorders",
            },
            {
              width: "50%",
              table: {
                widths: [70, "*"],
                body: [
                  ...(!isVedamaayu
                    ? [
                        [
                          { text: "Counsellor", bold: true, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, 6] },
                          { text: `:  ${patientInfo?.counsellorName || "—"}`, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, 6] },
                        ],
                      ]
                    : []),
                  [
                    { text: "Reg. Date", bold: true, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, 6] },
                    { text: `:  ${regDate || "—"}`, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, 6] },
                  ],
                  [
                    { text: "Adm. Date", bold: true, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, isVedamaayu ? 6 : 0] },
                    { text: `:  ${patientInfo?.admsnDate || "—"}`, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, isVedamaayu ? 6 : 0] },
                  ],
                  ...(isVedamaayu
                    ? [
                        [
                          { text: "Doctor", bold: true, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, 0] },
                          { text: `:  ${patientInfo?.doctorName || "—"}`, fontSize: 11, border: [false, false, false, false], margin: [0, 0, 0, 0] },
                        ],
                      ]
                    : []),
                ],
              },
              layout: "noBorders",
            },
          ],
          margin: [0, 0, 0, 20],
        },
        // ── Horizontal Separator Line ──
        // ── Horizontal Separator Line ──
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 575,
              y2: 0,
              lineWidth: 1,
              lineColor: "#000000",
            },
          ],
          margin: [0, 0, 0, 20],
        },

        // ── Vertical Divider Line ──
        {
          canvas: [
            {
              type: "line",
              x1: isVedamaayu ? 410 : 410,
              y1: isVedamaayu ? 150 : 155,
              x2: isVedamaayu ? 410 : 410,
              y2: isVedamaayu ? 830 : 830,
              lineWidth: 1,
              lineColor: "#000000",
            },
          ],
          absolutePosition: { x: 10, y: 10 },
        },

        // ── Advance Payments Table ──
        {
          stack: [
            {
              text: "Advance Payments",
              fontSize: 11,
              bold: true,
              alignment: "center",
              margin: [0, 0, 0, 10],
            },
            {
              table: {
                widths: ["auto", "auto", "auto"],
                body: advTableBody,
              },
              layout: {
                hLineWidth: function (i, node) { return 0.5; },
                vLineWidth: function (i, node) { return 0.5; },
                hLineColor: function (i, node) { return "#aaaaaa"; },
                vLineColor: function (i, node) { return "#aaaaaa"; },
                paddingLeft:   function (i, node) { return 3; },
                paddingRight:  function (i, node) { return 3; },
                paddingTop:    function (i, node) { return 3; },
                paddingBottom: function (i, node) { return 3; },
              },
            },
          ],
          absolutePosition: isVedamaayu
            ? { x: 430, y: 150 }
            : { x: 430, y: 185 },
        },
      ],
    };
  };

 /* const printCard = (advPayments) => {
    const docDefinition = buildDocDefinition(advPayments);
    pdfMake.createPdf(docDefinition).open();
  };*/
   const printCard = (advPayments) => {
    const docDefinition = buildDocDefinition(advPayments);

  pdfMake.createPdf(docDefinition).getBlob((blob) => {
  const url = URL.createObjectURL(blob);
  window.open(`/Patient_Profile_Print?file=${encodeURIComponent(url)}`, "_blank");
  });
   }
   
  return null;
}

export default PrintPatientCard;